import { Entity, MicroMClient } from "@mcurros2/microm";
import { PersonalAsignarFiltersDef } from "./PersonalAsignarFiltersDef";


export class PersonalAsignarFilters extends Entity<PersonalAsignarFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new PersonalAsignarFiltersDef(), parentKeys);
        this.Form = import('./PersonalAsignarFiltersForm').then((module) => module.PersonalAsignarFiltersForm);
        this.Title = "Personal Filters";
    }
}